/*
* Copyright (C) Regione Lombardia
*/
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PagesCmsAccessibilitaComponent } from './accessibilita/accessibilita.component';
import { PagesCmsComponent } from './cms/cms.component';
import { PagesCmsContattiComponent } from './contatti/contatti.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                component: PagesCmsComponent,
                children: [
                    { path: 'accessibilita', component: PagesCmsAccessibilitaComponent },
                    { path: 'contatti', component: PagesCmsContattiComponent },
                    { path: '**', redirectTo: 'accessibilita', pathMatch: 'full' },
                ]
            }
        ]),
    ],
    exports: [
        RouterModule,
    ]
})

export class PagesCmsRouting { }
